import {NgModule} from '@angular/core';
import {WidgetLinkingGroupPickerModule} from './widget-linking-group-picker';
import {WidgetLinkingGroupService} from './widget-linking-group.service';

@NgModule({
    imports: [
        WidgetLinkingGroupPickerModule
    ],
    providers: [
        WidgetLinkingGroupService
    ],
    exports: [
        WidgetLinkingGroupPickerModule
    ]
})
export class WidgetLinkingGroupModule {}
